<template>
    <div>
        <ui-modal ref="editModal" size="large" :title="(this.item.id ? 'Edit Expense #' + this.item.id : 'Add Expense Item')" @hide="$emit('hide')" dismiss-on="close-button esc">
            <div class="container-fluid" style="padding: 0; margin-top: 1rem;">
                
                <div class="row">
                    <div class="col-12">
                        <expense-category-picker
                            label="Item Category"
                            v-model="categoryProxy"
                            @input="categoryChange"
                            :disabled="!canEditCategory"
                        ></expense-category-picker>
                    </div>

                    <div v-show="item.expense_category && item.expense_category.id" class="col-12">
                        <vehicle-picker
                            label="Related Vehicle"
                            v-model="instanceProxy"
                            :disabled="disableInstanceSelection || !canEditVehicle"
                            :force-alien-lookup="false"
                            :force-stocking-status-selection="true"
                            :additional-relations-to-load="['location']"
                            @input="updateItemDetails(true)"
                            @cleared="purchasePriceOptionProxy = false"
                        ></vehicle-picker>
                    </div>

                    <div class="col">
                        <ui-textbox
                            label="Item Description"
                            v-model="item.description"
                            :disabled="disableDescription"
                        ></ui-textbox>
                    </div>
                    <div class="col-2">
                        <ui-textbox
                            label="Qty"
                            v-model="item.quantity"
                            type="number"
                            :disabled="disableDescription"
                        ></ui-textbox>
                    </div>
                    <div class="col-2">
                        <ui-textbox
                            label="Unit Net £'s"
                            v-model="item.unit_cost"
                            type="number"
                            step="5"
                        ></ui-textbox>
                    </div>
                    <div class="col-2" v-if="isCustomVat">
                        <ui-textbox
                            label="Total VAT £'s"
                            v-model="item.custom_total_vat"
                            type="number"
                            step="5"
                        ></ui-textbox>
                    </div>
                    <div class="col-2">
                        <vat-rate-selector
                            v-model="item.vat_rate"
                            @change="vatRateChanged"
                        />
                    </div>
                </div>

                <div v-if="supportsCustomVat" class="row align-items-center">

                <div class="col-5">
                    <ui-switch v-model="isCustomVat" :false-value="null">Custom VAT total</ui-switch>
                </div>

                </div>

            </div>
            <div slot="footer">
                <button class="btn btn-primary" @click="save" :disabled="!canSubmit">{{ buttonLabel }}</button>
            </div>
        </ui-modal>
    </div>
</template>

<script>
import {VatTariffList, VatTariffs} from '../../classes/VatService'
    import { ExpenseItemSchema, ExpenseCategorySchema } from '../../classes/Api/Expense'
    import VehiclePicker from './controls/KeenVehiclePicker'
    import ExpenseCategoryPicker from './controls/KeenExpenseCategoryPicker'
    import VatRateSelector from './controls/VatRateSelector'

    export default {
        components: { VehiclePicker, ExpenseCategoryPicker, VatRateSelector },
        props: {
            instance: {
                type: Object,
            },
            disableInstanceSelection: {
                type: Boolean,
            }
        },
        data() {
            return {
                VatTariffList,
                item: new ExpenseItemSchema({
                    instance: {},
                    category: {},
                    tasks: [],
                }),
            }
        },
        methods: {
            categoryChange(e) {
                if (e.default_tax_rate) {
                    this.item.vat_rate = e.default_tax_rate
                }

                if (e.id === this.defaultVehicleExpenseCategory.id) {
                    this.updateItemDetails(true);
                } else if (!this.item.description || 0 === this.item.description.length) {
                    this.item.description = this.item.expense_category.name
                }
            },
            updateItemDetails(value) {
                if (value === true && this.item.expense_category_id === this.defaultVehicleExpenseCategory.id) {
                    this.item.description = this.item.instance.search_description;
                    this.item.quantity = 1;
                }
            },
            open(item = null) {
                if (item) {
                    this.item = item;
                } else {
                    this.item = new ExpenseItemSchema({
                        instance: {},
                        expense_category: {},
                    });

                    this.instanceProxy = { id: null };
                    this.categoryProxy = { id: null };
                }

                if (this.instance && (!this.item.instance || !this.item.instance.id) && !this.item.id) {
                    this.instanceProxy = this.instance;
                }

                this.$refs['editModal'].open();
            },
            close() {
                this.$refs['editModal'].close();
            },
            save() {
                let item = Object.assign({}, this.item);

                this.$emit('save', item);

                this.$refs['editModal'].close();
            },
            vatRateChanged() {
                if (this.item.vat_rate === VatTariffs.NONE) {
                    this.item.custom_total_vat = null
                }
            }
        },
        computed: {
            supportsCustomVat() {
                return this.item.vat_rate !== VatTariffs.NONE
            },
            isCustomVat: {
                get() {
                    return this.item.custom_total_vat !== null
                },
                set(val) {
                    if (val === null) {
                        this.item.custom_total_vat = null;
                    } else {
                        this.item.custom_total_vat = 0;
                    }
                }
            },
            disableDescription() {
                return this.instanceProxy &&
                    this.instanceProxy.id &&
                    this.item.expense_category_id === this.defaultVehicleExpenseCategory.id;
            },
            canSubmit() {
                return this.item.description && this.item.description.length > 0 && 
                    this.item.quantity > 0 && 
                    this.item.unit_cost > 0 && 
                    this.item.expense_category_id > 0;
            },
            buttonLabel() {
                return this.item.id > 0 ? 'Update' : 'Add';
            },
            defaultVehicleExpenseCategory() {
                return window.marque.ui.defaultVehicleExpenseCategory;
            },
            canEditVehicle() {
                return this.item && (!this.item.tasks || 0 === this.item.tasks.length)
            },
            canEditCategory() {
                return this.item && (!this.item.tasks || 0 === this.item.tasks.length)
            },
            purchasePriceOptionProxy: {
                get() {
                    if (this.item.instance && this.item.expense_category_id === this.defaultVehicleExpenseCategory.id) {
                        return true;
                    }

                    return false;
                },
                set(value) {
                    if (value) {
                        this.categoryProxy = this.defaultVehicleExpenseCategory;
                    }

                    this.$set(this.item, 'is_vehicle_purchase', value);
                },
            },
            instanceProxy: {
                get() {
                    let instance = Object.assign({}, this.item.instance);

                    return instance;
                },
                set(value) {
                    this.$set(this.item, 'instance', value);
                    this.$set(this.item, 'instance_id', value.id ? value.id : null);
                }
            },
            categoryProxy: {
                get() {
                    return this.item.expense_category;
                },
                set(value) {
                    this.item.expense_category = value;
                    this.item.expense_category_id = value.id;
                }
            }
        }
    }
</script>